<template>
  <div class="info">
    <i class="icon-mail"></i>
    <a href="mailto:hello@tourhero.com">hello@tourhero.com</a>
    <i class="icon-pin">
      <PinIcon />
    </i>
    <div>28-07 Jackson Avenue, Long Island City, NY 11101, USA</div>
  </div>
</template>

<script setup>
import PinIcon from 'app/assets/images/common/pin.svg?component'
</script>

<style lang="scss" scoped>
.info {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: flex-start;
  row-gap: 16px;
  column-gap: 10px;

  a {
    color: $brand-primary;
  }
}

.icon-mail,
.icon-phone,
.icon-pin {
  font-size: 20px;
  line-height: 1;
}

.icon-pin svg {
  height: 20px;
}
</style>
